<template>
  <div class="flex-1 min-h-0 p-6">
    <router-link :to="{ name: 'Agent' }" class="btn-primary-sm text-xs inline-block">Open the agent</router-link>
  </div>
</template>

<script>
export default {
  name: 'WizardManager',
};
</script>
